import * as types from './CapacityvsDemandTableActionType';

//----Fetch Capacity Dropdown list ----//
export const fetchCapacityDDListRequest = () => ({
    type: types.FETCH_CAPACITY_REPORT_DDLIST_REQUEST,
});
export const fetchCapacityDDListSuccess = (payload) => ({
    type: types.FETCH_CAPACITY_REPORT_DDLIST_SUCCESS,
    payload,
});
export const fetchCapacityDDListFailure = (error) => ({
    type: types.FETCH_CAPACITY_REPORT_DDLIST_FAILURE,
    error,
});

//-----Fetch Capacity vs Demand Report List ----//
export const fetchCapsVsDemandReportRequest = (payload) => ({
    type: types.FETCH_CAPACITYVsDEMAND_REPORT_REQUEST,
    payload,
});
export const fetchCapsVsDemandReportSuccess = (payload) => ({
    type: types.FETCH_CAPACITYVsDEMAND_REPORT_SUCCESS,
    payload,
});
export const fetchCapsVsDemandReportFailure = (error) => ({
    type: types.FETCH_CAPACITYVsDEMAND_REPORT_FAILURE,
    error,
});

//----- Fetch Available Shift Data ----//
export const fectchAvailableShiftRequest = (payload) => ({
    type: types.FETCH_AVAILABLE_SHIFT_REQUEST,
    payload,
});
export const fectchAvailableShiftSuccess = (payload) => ({
    type: types.FETCH_AVAILABLE_SHIFT_SUCCESS,
    payload,
});
export const fectchAvailableShiftFailure = (error) => ({
    type: types.FETCH_AVAILABLE_SHIFT_FAILURE,
    error,
});

//----- Fetch Available Shift Filter DDList ----//
export const fetchAvailableshiftFilterDDListRequest = (payload) => ({
    type: types.FETCH_AVAILABLE_SHIFT_FILTERDDLIST_REQUEST,
    payload,
});

export const fetchAvailableshiftFilterDDListSuccess = (payload) => ({
    type: types.FETCH_AVAILABLE_SHIFT_FILTERDDLIST_SUCCESS,
    payload,
});

export const fetchAvailableshiftFilterDDListFailure = (error) => ({
    type: types.FETCH_AVAILABLE_SHIFT_FILTERDDLIST_FAILURE,
    error,
});

//----- Fetch Legend Data ----//
export const fetchLegendDataRequest = (payload) => ({
    type: types.FETCH_AVAILABLESHIFT_LEGEND_REQUEST,
    payload,
});

export const fetchLegendDataSuccess = (payload) => ({
    type: types.FETCH_AVAILABLESHIFT_LEGEND_SUCCESS,
    payload,
});

export const fetchLegendDataFailure = (error) => ({
    type: types.FETCH_AVAILABLESHIFT_LEGEND_FAILURE,
    error,
});

//----- Fetch Worklist By Worklist Group DDList (cascading Worklist filter) ----//
// payload on request: { WorklistGroupIDs, tabKey }; tabKey ("capVsDem" / "availableShifts")
// keeps each tab's list separate in the shared reducer slice.
export const fetchCapsWorklistByGroupDDListRequest = (payload) => ({
    type: types.FETCH_CAPS_WORKLIST_BY_GROUP_DD_REQUEST,
    payload,
});

export const fetchCapsWorklistByGroupDDListSuccess = (payload) => ({
    type: types.FETCH_CAPS_WORKLIST_BY_GROUP_DD_SUCCESS,
    payload,
});

export const fetchCapsWorklistByGroupDDListFailure = (error) => ({
    type: types.FETCH_CAPS_WORKLIST_BY_GROUP_DD_FAILURE,
    error,
});

//----- Fetch Available Shift RPCE Data ----//
export const fetchAvailableShiftRPCERequest = (payload) => ({
    type: types.FETCH_AVAILABLE_SHIFT_RPCE_REQUEST,
    payload,
});
export const fetchAvailableShiftRPCESuccess = (payload) => ({
    type: types.FETCH_AVAILABLE_SHIFT_RPCE_SUCCESS,
    payload,
});
export const fetchAvailableShiftRPCEFailure = (error) => ({
    type: types.FETCH_AVAILABLE_SHIFT_RPCE_FAILURE,
    error,
});

//-----Fetch Available Shift Worklist Data ----//
export const fetchAvailableShiftWorklistRequest = (payload) => ({
    type: types.FETCH_AVAILABLE_WORKLISTDATA_REQUEST,
    payload,
});
export const fetchAvailableShiftWorklistSuccess = (payload) => ({
    type: types.FETCH_AVAILABLE_WORKLISTDATA_SUCCESS,
    payload,
});
export const fetchAvailableShiftWorklistFailure = (error) => ({
    type: types.FETCH_AVAILABLE_WORKLISTDATA_FAILURE,
    error,
});

//----- Fetch RPCE DATA in CapsVsDemand tab ----//
export const fetchCapsVsDemandShiftRPCERequest = (payload) => ({
    type: types.FETCH_RPCE_DATA_CAPSVSDEMAND_REQUEST,
    payload,
});
export const fetchCapsVsDemandShiftRPCESuccess = (payload) => ({
    type: types.FETCH_RPCE_DATA_CAPSVSDEMAND_SUCCESS,
    payload,
});
export const fetchCapsVsDemandShiftRPCEFailure = (error) => ({
    type: types.FETCH_RPCE_DATA_CAPSVSDEMAND_FAILURE,
    error,
});

//----- Fetch Worklist DATA in CapsVsDemand tab ----//
export const fetchCapsVsDemandShiftWorklistRequest = (payload) => ({
    type: types.FETCH_WORKLIST_DATA_CAPSVSDEMAND_REQUEST,
    payload,
});
export const fetchCapsVsDemandShiftWorklistSuccess = (payload) => ({
    type: types.FETCH_WORKLIST_DATA_CAPSVSDEMAND_SUCCESS,
    payload,
});
export const fetchCapsVsDemandShiftWorklistFailure = (error) => ({
    type: types.FETCH_WORKLIST_DATA_CAPSVSDEMAND_FAILURE,
    error,
});

//----- Fetch Capacity Details in CapsVsDemand tab on popup ----//
export const fetchCapacityPopupDetailsRequest = (payload) => ({
    type: types.FETCH_CAPACITY_HOVER_DETAILS_REQUEST,
    payload,
});
export const fetchCapacityPopupDetailsSuccess = (payload) => ({
    type: types.FETCH_CAPACITY_HOVER_DETAILS_SUCCESS,
    payload,
});
export const fetchCapacityPopupDetailsFailure = (error) => ({
    type: types.FETCH_CAPACITY_HOVER_DETAILS_FAILURE,
    error,
});

//----- Fetch Worklist Details in CapsVsDemand tab on popup ----//
export const fetchWorklistDetailRequest = (payload) => ({
    type: types.FETCH_WORKLIST_HOVER_DETAILS_REQUEST,
    payload,
});
export const fetchWorklistDetailSuccess = (payload) => ({
    type: types.FETCH_WORKLIST_HOVER_DETAILS_SUCCESS,
    payload,
});
export const fetchWorklistDetailFailure = (error) => ({
    type: types.FETCH_WORKLIST_HOVER_DETAILS_FAILURE,
    error,
});

//----- Fetch Capacity Vs Demand Get By Id Details ----//
export const fetchCapsVsDemandDetailsByIdRequest = (payload) => ({
    type: types.FETCH_GETBY_ID_DETAILS_REQUEST,
    payload,
});
export const fetchCapsVsDemandDetailsByIdSuccess = (payload) => ({
    type: types.FETCH_GETBY_ID_DETAILS_SUCCESS,
    payload,
});
export const fetchCapsVsDemandDetailsByIdFailure = (error) => ({
    type: types.FETCH_GETBY_ID_DETAILS_FAILURE,
    error,
});

//----- Fetch Notes Details ----//
export const fecthCapsVsdemandNotesDetailsRequest = (payload) => ({
    type: types.FETCH_CAPSVSDEMAND_NOTES_DETAILS_REQUEST,
    payload,
});
export const fetchCapsVsdemandNotesDetailsSuccess = (payload) => ({
    type: types.FETCH_CAPSVSDEMAND_NOTES_DETAILS_SUCCESS,
    payload,
});
export const fetchCapsVsdemandNotesDetailsFailure = (error) => ({
    type: types.FETCH_CAPSVSDEMAND_NOTES_DETAILS_FAILURE,
    error,
});

//----- Save Notes Details ----//
export const saveCapsVsDemandNotesRequest = (payload) => ({
    type: types.SAVE_CAPSVSDEMAND_NOTES_REQUEST,
    payload,
});
export const saveCapsVsDemandNotesSuccess = (payload) => ({
    type: types.SAVE_CAPSVSDEMAND_NOTES_SUCCESS,
    payload,
});
export const saveCapsVsDemandNotesFailure = (error) => ({
    type: types.SAVE_CAPSVSDEMAND_NOTES_FAILURE,
    error,
});

//----- Publish Caps Vs Demand Report ----//
export const PublishCapsVsDemandRequest = (payload) => ({
    type: types.PUBLISH_CAPSVSDEMAND_REPORT_REQUEST,
    payload,
});
export const PublishCapsVsDemandSuccess = (payload) => ({
    type: types.PUBLISH_CAPSVSDEMAND_REPORT_SUCCESS,
    payload,
});
export const PublishCapsVsDemandFailure = (error) => ({
    type: types.PUBLISH_CAPSVSDEMAND_REPORT_FAILURE,
    error,
});

//----- Export on RPCE data in Available shift ----//
export const exportRPCEDataAvailableShift = (payload) => ({
    type: types.EXPORT_RPCE_DATA_AVAILABLESHIFT_REQUEST,
    payload,
});
export const exportRPCEDataAvailableShiftSuccess = (payload) => ({
    type: types.EXPORT_RPCE_DATA_AVAILABLESHIFT_SUCCESS,
    payload,
});
export const exportRPCEDataAvailableShiftFailure = (error) => ({
    type: types.EXPORT_RPCE_DATA_AVAILABLESHIFT_FAILURE,
    error,
});

//----- Export on Worklist data in Available shift ----//
export const exportWorklistDataAvailableShift = (payload) => ({
    type: types.EXPORT_WORKLIST_DATA_AVAILABLESHIFT_REQUEST,
    payload,
});
export const exportWorklistDataAvailableShiftSuccess = (payload) => ({
    type: types.EXPORT_WORKLIST_DATA_AVAILABLESHIFT_SUCCESS,
    payload,
});
export const exportWorklistDataAvailableShiftFailure = (error) => ({
    type: types.EXPORT_WORKLIST_DATA_AVAILABLESHIFT_FAILURE,
    error,
});

//----- Export RPCE Data in Caps Vs Demand tab ----//
export const exportRPCECapsVsDemandRequest = (payload) => ({
    type: types.EXPORT_RPCE_CAPSVSDEMAND_REQUEST,
    payload,
});
export const exportRPCECapsVsDemandSuccess = (payload) => ({
    type: types.EXPORT_RPCE_CAPSVSDEMAND_SUCCESS,
    payload,
});
export const exportRPCECapsVsDemandFailure = (error) => ({
    type: types.EXPORT_RPCE_CAPSVSDEMAND_FAILURE,
    error,
});

//----- Export Worklist Data in Caps Vs Demand tab ----//
export const exportWorklistCapsVsDemandRequest = (payload) => ({
    type: types.EXPORT_WORKLIST_CAPSVSDEMAND_REQUEST,
    payload,
});
export const exportWorklistCapsVsDemandSuccess = (payload) => ({
    type: types.EXPORT_WORKLIST_CAPSVSDEMAND_SUCCESS,
    payload,
});
export const exportWorklistCapsVsDemandFailure = (error) => ({
    type: types.EXPORT_WORKLIST_CAPSVSDEMAND_FAILURE,
    error,
});

//----- Delete Caps Vs Demand Report ----//
export const deleteCapsVsDemandRequest = (CapsVsdemandid) => ({
    type: types.DELETE_CAPSVSDEMAND_REPORT_REQUEST,
    payload: { CapsVsdemandid }
});
export const deleteCapsVsDemandSuccess = (CapsVsdemandid) => ({
    type: types.DELETE_CAPSVSDEMAND_REPORT_SUCCESS,
    payload: CapsVsdemandid
});
export const deleteCapsVsDemandFailure = (error) => ({
    type: types.DELETE_CAPSVSDEMAND_REPORT_FAILURE,
    payload: error
});

//----- Export Caps Vs Demand Report ----//
export const exportCapsVsDemandReportRequest = (payload) => ({
    type: types.EXPORT_CAPSVSDEMAND_REPORT_REQUEST,
    payload,
});
export const exportCapsVsDemandReportSuccess = (payload) => ({
    type: types.EXPORT_CAPSVSDEMAND_REPORT_SUCCESS,
    payload,
});
export const exportCapsVsDemandReportFailure = (error) => ({
    type: types.EXPORT_CAPSVSDEMAND_REPORT_FAILURE,
    error,
});

//----- Generate Capacity Vs Demand Report (Encore) ----//
export const generateCapsVsDemandReportEncoreRequest = (payload) => ({
    type: types.GENERATE_CAPSVSDEMAND_REPORT_ENCORE_REQUEST,
    payload,
});
export const generateCapsVsDemandReportEncoreSuccess = (payload) => ({
    type: types.GENERATE_CAPSVSDEMAND_REPORT_ENCORE_SUCCESS,
    payload,
});
export const generateCapsVsDemandReportEncoreFailure = (error) => ({
    type: types.GENERATE_CAPSVSDEMAND_REPORT_ENCORE_FAILURE,
    error,
});

//----- Fetch Capacity Vs Demand Tab Details With Pagination (Encore) ----//
export const fetchCapsVsDemandTabDetailsEncoreRequest = (payload) => ({
    type: types.FETCH_CAPSVSDEMAND_TABDETAILS_ENCORE_REQUEST,
    payload,
});
export const fetchCapsVsDemandTabDetailsEncoreSuccess = (payload) => ({
    type: types.FETCH_CAPSVSDEMAND_TABDETAILS_ENCORE_SUCCESS,
    payload,
});
export const fetchCapsVsDemandTabDetailsEncoreFailure = (error) => ({
    type: types.FETCH_CAPSVSDEMAND_TABDETAILS_ENCORE_FAILURE,
    error,
});

//----- Fetch Available Shifts Tab Details With Pagination (Encore) ----//
export const fetchAvailableShiftsTabDetailsEncoreRequest = (payload) => ({
    type: types.FETCH_AVAILABLESHIFTS_TABDETAILS_ENCORE_REQUEST,
    payload,
});
export const fetchAvailableShiftsTabDetailsEncoreSuccess = (payload) => ({
    type: types.FETCH_AVAILABLESHIFTS_TABDETAILS_ENCORE_SUCCESS,
    payload,
});
export const fetchAvailableShiftsTabDetailsEncoreFailure = (error) => ({
    type: types.FETCH_AVAILABLESHIFTS_TABDETAILS_ENCORE_FAILURE,
    error,
});

//----- Fetch Access To Demand Details With Pagination (hour cell popup) ----//
export const fetchAccessToDemandRequest = (payload) => ({
    type: types.FETCH_ACCESS_TO_DEMAND_REQUEST,
    payload,
});
export const fetchAccessToDemandSuccess = (payload) => ({
    type: types.FETCH_ACCESS_TO_DEMAND_SUCCESS,
    payload,
});
export const fetchAccessToDemandFailure = (error) => ({
    type: types.FETCH_ACCESS_TO_DEMAND_FAILURE,
    error,
});

//----- Export Capacity Vs Demand Report (Encore) ----//
export const exportCapsVsDemandReportEncoreRequest = (payload) => ({
    type: types.EXPORT_CAPSVSDEMAND_REPORT_ENCORE_REQUEST,
    payload,
});
export const exportCapsVsDemandReportEncoreSuccess = (payload) => ({
    type: types.EXPORT_CAPSVSDEMAND_REPORT_ENCORE_SUCCESS,
    payload,
});
export const exportCapsVsDemandReportEncoreFailure = (error) => ({
    type: types.EXPORT_CAPSVSDEMAND_REPORT_ENCORE_FAILURE,
    error,
});

//----- Delete Capacity Vs Demand Report (Encore) ----//
export const deleteCapsVsDemandEncoreRequest = (CapacityVsDemandTableID) => ({
    type: types.DELETE_CAPSVSDEMAND_REPORT_ENCORE_REQUEST,
    payload: { CapacityVsDemandTableID },
});
export const deleteCapsVsDemandEncoreSuccess = (payload) => ({
    type: types.DELETE_CAPSVSDEMAND_REPORT_ENCORE_SUCCESS,
    payload,
});
export const deleteCapsVsDemandEncoreFailure = (error) => ({
    type: types.DELETE_CAPSVSDEMAND_REPORT_ENCORE_FAILURE,
    error,
});

//----- Publish Capacity Vs Demand Report (Encore) ----//
export const publishCapsVsDemandEncoreRequest = (payload) => ({
    type: types.PUBLISH_CAPSVSDEMAND_REPORT_ENCORE_REQUEST,
    payload,
});
export const publishCapsVsDemandEncoreSuccess = (payload) => ({
    type: types.PUBLISH_CAPSVSDEMAND_REPORT_ENCORE_SUCCESS,
    payload,
});
export const publishCapsVsDemandEncoreFailure = (error) => ({
    type: types.PUBLISH_CAPSVSDEMAND_REPORT_ENCORE_FAILURE,
    error,
});